import React from 'react';

import BasicDropdown from '../../base/dropdowns/basic-dropdown';

import './sortby-dropdown.scss';

const SortbyDropdown = ({sortOptions, sortBy, setSortBy, type, label, direction, setDirection}) => {
	const dropdownlabel = label ? (<span className="label">Sort by:</span>) : null;
	return (
		<div className="sortby-dropdown">
			{dropdownlabel}
			<BasicDropdown
				items={sortOptions}
				selectItem={(idx) => setSortBy(sortOptions[idx])}
				dropdownLabel={sortBy.label}
				initialSelection={sortOptions.findIndex((item) => item.label === sortBy.label)}
				type={type}
				setDirection={setDirection}
				direction={direction}
			/>
		</div>
	);
};

export default SortbyDropdown;
